import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import { StudentsClient } from '../components/students/StudentsClient'

function StudentsError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load students.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/students/')({
  head: () => ({
    meta: [{ title: 'Students | Unbreakable' }],
  }),
  errorComponent: StudentsError,
  component: StudentsPage,
})

function StudentsPage() {
  return (
    <AuthGuard>
      <StudentsClient />
    </AuthGuard>
  )
}
